import React from "react";
import Verifications from "./Verifications";

export default function CommercialDriverVerifications() {
  return <Verifications segment="commercial_driver" title="Taxi Verification" description="Commercial bike, autorickshaw & taxi cars — includes taxi permit and vehicle details." />;
}
